import { Typography } from '@breetometer/components';
import { Dropdown } from 'BreetComponents';
import type { ICurrencyDropDownItem } from 'BreetHelpers';
import { useWalletBalance } from 'BreetHooks';
import { selectFiatMeta, useAppSelector } from 'BreetRedux';
import { type MouseEvent, useCallback } from 'react';

const SelectWallet = ({
	selectWallet,
	selectedWallet,
}: {
	selectedWallet?: ICurrencyDropDownItem;
	selectWallet?: (wallet: ICurrencyDropDownItem) => void;
}) => {
	const { getBalance } = useWalletBalance();

	const fiatMeta = useAppSelector(selectFiatMeta);

	const defaultSelectedWallet: ICurrencyDropDownItem = {
		currency: fiatMeta.currency,
		walletBalance: getBalance(fiatMeta.currency),
	};

	const handleItemSelect = useCallback(
		(item: ICurrencyDropDownItem) => (e: MouseEvent<HTMLButtonElement>) => {
			e.stopPropagation();
			selectWallet?.(item);
		},
		[selectWallet]
	);

	return (
		<div className='select-wallet-container'>
			<Typography className='color-primary-100'>Where do you want to withdraw from?</Typography>
			<div className='select-wallet'>
				<Dropdown.Currency
					items={[
						{
							currency: fiatMeta.currency,
							walletBalance: getBalance(fiatMeta.currency),
						},
						{
							currency: 'USD',
							walletBalance: getBalance('USD'),
						},
					]}
					placeholder='Select Wallet'
					label=''
					hideSearch
					id='select-wallet-balance'
					selectedItem={selectedWallet ?? defaultSelectedWallet}
					handleItemSelect={handleItemSelect}
				/>
			</div>
		</div>
	);
};

export default SelectWallet;
